





















import { Vue, Component, Prop } from "vue-property-decorator";
import type { ICustomStylingClass, subGroupType } from "./types/custom.t";
import Swatch from '@/components/Globals/molecule.swatch.vue'
import CustomContainer from "./CustomContainer.vue";
import CustomText from "@/components/Globals/CustomText.vue"

@Component({ components: { CustomContainer, CustomText, Swatch } })
export default class SwatchSubgroup extends Vue {

  @Prop()
  customsClasses?: ICustomStylingClass[];

  @Prop()
  subgroup!: subGroupType;

  @Prop({default: ''})
	groupName!: string;

  get activeComponent() {
    if (this.$store.getters['utils/isApparelEnabled']){
      return this.$store.state.standardNavigation.activeSubComponent
        ? `${this.$store.state.standardNavigation.activeComponent}/${this.$store.state.standardNavigation.activeSubComponent}`
        : this.$store.state.standardNavigation.activeComponent;
    }
    return this.$store.state.legacyNavigation.activeComponent;
  }

  get ugcBlockedPalette() {
    return this.$store.state.ugc.ugcBlockedPalettes[this.activeComponent] || null;
  }

  get isSubgroupHidden() {
    let visibleByUgcBlock = true;

    if (this.ugcBlockedPalette) {
      visibleByUgcBlock = parseInt(this.$props.subgroup.palette_id) === this.ugcBlockedPalette;
    }

    return visibleByUgcBlock && this.$props.subgroup.swatches?.length > 0;
  }

  get hasNoSubgroups() {
    const group = 'solids';
    let componentName = this.activeComponent;
    if (String(this.activeComponent).search('/') !== -1) {
      componentName = 'sub_component';
    }
    const swatchData = this.$store.state.swatches.swatchesByComponent &&
      this.$store.state.swatches.swatchesByComponent[componentName] &&
      this.$store.state.swatches.swatchesByComponent[componentName][this.$props.groupName];

    return this.$props.groupName === group &&
      !!swatchData && Object.keys(swatchData).length === 1 &&
      !!swatchData[group] && !!swatchData[group].length;

  }

  get pdm() {
    return this.$store.state.utils.pdm;
  }

  /**
   * @function getUpchargeDisplay
   * @param {String} groupName - Name of the swatch main group (solids, materials, etc.)
   * @param {String} subGroupName - Name of the swatch subgroup (simpsons, checkerboards, etc.)
   * This method checks if a translation for upcharge exists and return it
   * if it doesn't exist by component it checks then by default and group and subgroup
   */
  getUpchargeDisplay(groupName: string, subGroupName: string) {
    const sku = this.pdm.sku;
    const activeComponent = this.activeComponent;
    let model;
    try {
      model = this.$store.state.translations.upcharge?.[sku]?.[activeComponent]?.[groupName];
      if(model?.[subGroupName]) {
        return model?.[subGroupName]?.toLowerCase() === "blankspace" ? '' : `(${model?.[subGroupName]})`;
      } else {
          model = this.$store.state.translations.upcharge["default"]?.[activeComponent]?.[groupName];
          if(model?.[subGroupName]) {
            return model?.[subGroupName].toLowerCase() !== "blankspace" ? `(${model?.[subGroupName]})` :'';
          }
      }
    } catch (err) {
      console.error("The upcharge display is not available", err);
    }
    return "";
  }
}
